
import { Sketch } from "./components/Sketch";

new Sketch(document.querySelector("canvas.webgl"));
